"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCreator = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var conferenceViewLoad_1 = require("./conferenceViewLoad");
var conferenceClick_1 = require("./conferenceClick");
var creatorMappings = (_a = {},
    _a[analytics_layer_1.ConferenceViewLoadEventNames.ConferenceViewLoad] = conferenceViewLoad_1.conferenceViewLoad,
    _a[analytics_layer_1.ConferenceViewLoadEventNames.ConferenceClick] = conferenceClick_1.conferenceClick,
    _a);
var getCreator = function (eventName) { return creatorMappings[eventName]; };
exports.getCreator = getCreator;
